import { Box, styled } from "@mui/material";

export const MainAreaWrapper = styled(Box)(({ theme }) => {
    return {
        padding: "var(--basic-padding)",
        overflow: "hidden",
        [theme.breakpoints.up("tablet")]: {
            position: "absolute",
            padding: "var(--basic-padding) 0",
            left: "calc(var(--side-nav-width) + var(--basic-padding))",
            right: "var(--basic-padding)",
            top: "calc(var(--top-nav-height) + calc(var(--basic-padding) * 2))"
        },
        [theme.breakpoints.between("tablet", "laptop")]: {
            top: "calc(var(--top-nav-height) + calc(var(--basic-padding) * 2.56))",
        }
    }
})
